
import SearchInput from '~/components/widgets/SearchHome/SearchInput/SearchInput';
import MobileMenu from '~/components/header/mobile/MobileMenu';
import Socials from '~/components/common/Socials.vue';

export default {
  name: 'MobileMenuContent',
  data() {
    return {
      isCatalogOpen: false,
    };
  },

  components: {
    Socials,
    MobileMenu,
    SearchInput,
    LazyMobileSidebar: () => import('~/components/common/LazyMobileSidebar'),
    LazyMobileCatalog: () => import('~/components/header/mobile/LazyMobileCatalog'),
  },

  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    currentCity() {
      return this.$store.state.appState?.config?.city?.model?.name;
    },

    contactEmail() {
      return this.vars?.email;
    },

    contactPhone() {
      return this.$store.state.currentPhone.currentPhone || '';
    },

    vars() {
      return this.$store.state?.appState?.vars || {};
    },
  },

  methods: {
    openCityModal() {
      this.$store.commit('city-select/setOpen', true);
    },

    switchCatalog() {
      this.isCatalogOpen = !this.isCatalogOpen;
    },

    closeMenu() {
      this.$store.commit('mobile-menu/switchBtn', false);
    },
  },
};
